import DeviceItem from "./DeviceItem";
import IcUnCheckedCircle from "@/assets/svg/ic_unchecked_circle.svg?react";
import IcCheckedCircle from "@/assets/svg/ic_checked_circle.svg?react";
import IcMicrophone from "@/assets/svg/ic_microphone.svg?react";
import ImgByom from "@/assets/svg/img_byom.svg?react";
import { toast } from "react-toastify";
import MeetingHandler from "@/bussiness/MeetingHandler";
import { ICustomeDevcie } from "@/types/device";
import { localDevice, useMicSwitcherContext } from "./context";
import { RuningInLink } from "@/constants";
import useClickOutSide from "@/utils/useClickOutSide";
import { useLayoutEffect, useRef } from "react";
import recordStore from "@/store/record.store";
import fridayReporter from "@/utils/friday";
import { message } from "antd";

function MicList(props: {
  micList: MediaDeviceInfo[];
  selectedMic?: MediaDeviceInfo;
  onSelect?: (mic: MediaDeviceInfo) => void;
}) {
  const { micList, selectedMic, onSelect } = props;
  const isOnline = recordStore((state) => state.isOnline);

  return (
    <div className="m-t-2">
      {micList.map((mic) => (
        <div
          key={mic.deviceId}
          className={`h-8 p-x-4 flex items-center gap-4 text-3.5 ${isOnline ? 'cursor-pointer' : 'cursor-not-allowed'} hover:bg-mx-secondary hover:bg-op-05`}
          onClick={() => onSelect?.(mic)}
        >
          {mic.deviceId === selectedMic?.deviceId ? (
            <IcCheckedCircle className="w-4 h-4 min-w-4 m-r-1" />
          ) : (
            <IcUnCheckedCircle className="w-4 min-w-4 h-4 m-r-1" />
          )}
          <span className="mx-text-ellipsis">{mic.label}</span>
        </div>
      ))}
    </div>
  );
}

function IfpdDeviceList() {
  const { state, dispatch } = useMicSwitcherContext();
  const isOnline = recordStore((state) => state.isOnline);

  // const handleSwitchDevice = async (device: ICustomeDevcie) => {
  //   if (!isOnline) return;
  //   try {
  //     await MeetingHandler.switchDevice(device);
  //     dispatch({ type: "updateCurrentDevice", payload: device });
  //     message.success(`已切换到"${device.name}"`, {
  //       icon: IcMicrophone,
  //     });
  //     // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   } catch (error: any) {
  //     console.log("handleSwitchDevice", error);
  //     const errMsg = error?.message || "切换设备失败，请重试";
  //     message.error(errMsg);
  //   }
  // };

  const handleGoConnect = () => {
    if (!isOnline) return;
    fridayReporter.pushData({
      eventCode: 'RecordPage_CutMic_NoDevice'
    })
    dispatch({ type: "updateMicModal", payload: false });
    dispatch({ type: "updateConnectModal", payload: !state.showConnectModal });
  };

  return (
    <>
      {state.currentDevice && state.currentDevice.type === "ifpd" && (
        <DeviceItem device={state.currentDevice} selected={true} />
      )}
      {/* {state.displayDevices?.map((device) => (
        <DeviceItem
          key={device.key}
          device={device}
          onSelect={handleSwitchDevice}
          selected={false}
        />
      ))} */}

      {state.currentDevice?.type === "computer" && <div className="flex flex-col items-center m-t-1">
        <ImgByom className="w-25 h-25" />
        <span className="m-t-1 text-#A1A7B2 text-3 line-height-4.25 mb-2">调用附近拾音设备提升采集质量</span>
        <button
          className={`w-20 ${isOnline ? 'bg-mx-primary hover:bg-#4981F2E6' : 'bg-#C7DFFF'} h-6.75 rd-25 px-4 text-white text-size-3  outline-none border-none`}
          disabled={!isOnline}
          onClick={handleGoConnect}
        >
          输码连接
        </button>
      </div>}
    </>
  );
}

function MicSelectorModal() {
  const { state, dispatch } = useMicSwitcherContext();
  const ref = useRef<HTMLDivElement>(null);
  const isOnline = recordStore((state) => state.isOnline);

  useLayoutEffect(() => {
    const observer = new ResizeObserver((entrys) => {
      const target = entrys[0].target as HTMLElement;
      const rect = target.getBoundingClientRect();
      target.style.top = `calc(-100% - ${rect.height}px - 10px)`;
    });
    observer.observe(ref.current!);
    return () => {
      observer.disconnect();
    };
  }, []);

  useClickOutSide(ref, (e) => {
    e?.stopPropagation();
    dispatch({ type: "updateMicModal", payload: false });
  });

  const handleSwitchDevice = async (device: ICustomeDevcie) => {
    if (!isOnline) return;
    try {
      await MeetingHandler.switchDevice(device);
      dispatch({ type: "updateCurrentDevice", payload: device });
      toast.success(`已切换到"${device.name}"`, {
        icon: IcMicrophone,
      });
      fridayReporter.pushData({
        eventCode: 'RecordPage_CutMic_CutDevice'
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("handleSwitchDevice", error);
      const errMsg = error?.message || "切换设备失败，请重试";
      message.error(errMsg);
    }
  };

  const handleSwitchMic = (mic: MediaDeviceInfo) => {
    if (!isOnline) return;
    fridayReporter.pushData({
      eventCode: 'RecordPage_CutMic'
    })
    dispatch({ type: "updateCurrentMic", payload: mic });
    MeetingHandler.switchMicrophone(mic);
    toast.success(`已切换到"${mic.label}"拾音`, {
      icon: IcMicrophone,
    });
  };

  return (
    <div
      ref={ref}
      className="w-60 max-h-102 p-t-2 p-b-4 position-absolute top--100 left-0 bg-mx-white rounded-2 shadow-mx overflow-x-hidden overflow-y-auto"
    >
      <div className="h-7.25 p-x-4 p-y-2 c-mx-tertiary text-3 line-height-4.25">
        选择采集设备
      </div>
      <div className="p-b-4 m-t-2 flex flex-col gap-2">
        <DeviceItem
          device={localDevice}
          onSelect={handleSwitchDevice}
          selected={localDevice.code === state.currentDevice?.code}
        />
        {RuningInLink && <IfpdDeviceList />}
      </div>
      {state.currentDevice?.type === "computer" && (
        <div className="mx-border-t">
          <div className="p-x-4 p-t-2 p-b-1 m-t-2 c-mx-tertiary text-3 line-height-4.25">
            麦克风
          </div>
          <MicList
            micList={state.micList}
            selectedMic={state.currentMic}
            onSelect={handleSwitchMic}
          />
        </div>
      )}
    </div>
  );
}

export default MicSelectorModal;
